import {ReactElement, ReactNode, useState, useRef, useEffect} from 'react';
import clsx from 'clsx';
import {Link} from 'react-router-dom';
import {useAuth} from '@common/auth/use-auth';
import {NotificationDialogTrigger} from '@common/notifications/dialog/notification-dialog-trigger';
import {Menu, MenuTrigger} from '@common/ui/navigation/menu/menu-trigger';
import {useCustomMenu} from '@common/menus/use-custom-menu';
import {createSvgIconFromTree} from '@common/icons/create-svg-icon';
import {useTrans} from '@common/i18n/use-trans';
import {Trans} from '@common/i18n/trans';
import {IconButton} from '@common/ui/buttons/icon-button';
import {useIsMobileMediaQuery} from '@common/utils/hooks/is-mobile-media-query';
import {Item} from '@common/ui/forms/listbox/item';
import {useNavigate} from '@common/utils/hooks/use-navigate';
import {useIsDarkMode} from '@common/ui/themes/use-is-dark-mode';
import {CustomMenu} from '@common/menus/custom-menu';
import {useSettings} from '@common/core/settings/use-settings';
import {ButtonColor} from '@common/ui/buttons/get-shared-button-style';
import {MenuIcon} from '@common/icons/material/Menu';
import {Select} from '../../../ui/forms/select/select';
import {MenuItemConfig} from '@common/core/settings/settings';
import {useChangeLocale} from '@common/i18n/change-locale';
import {useValueLists} from '../../../http/value-lists';
import {useBootstrapData} from '@common/core/bootstrap-data/bootstrap-data-context';
import {
  NavbarAuthUser,
  NavbarAuthUserProps,
} from '@common/ui/navigation/navbar/navbar-auth-user';
import {NavbarAuthButtons} from '@common/ui/navigation/navbar/navbar-auth-buttons';
import {useToggleSidebar} from '@app/contexts/toggleSidebar';
import styles from './ai.module.css';
import Lottie from 'react-lottie-player';
import animationData from './Animation .json';

type NavbarColor = 'primary' | 'bg' | 'bg-alt' | 'transparent';

export interface NavbarProps {
  hideLogo?: boolean;
  toggleButton?: ReactElement;
  children?: ReactNode;
  className?: string;
  color?: NavbarColor;
  darkModeColor?: NavbarColor;
  logoColor?: 'dark' | 'light';
  textColor?: string;
  primaryButtonColor?: ButtonColor;
  border?: string;
  size?: 'xs' | 'sm' | 'md';
  rightChildren?: ReactNode;
  menuPosition?: string;
  authMenuItems?: NavbarAuthUserProps['items'];
  value?: string;
}

export function Navbar({
  hideLogo,
  toggleButton,
  children,
  className,
  border,
  size = 'md',
  color = 'primary',
  darkModeColor = 'bg-alt',
  textColor,
  rightChildren,
  menuPosition,
  logoColor,
  primaryButtonColor,
  authMenuItems,
  value = '',
}: NavbarProps) {
  const isMobile = useIsMobileMediaQuery();
  const isDarkMode = useIsDarkMode();
  const {notifications} = useSettings();
  const {isLoggedIn, user} = useAuth();
  const [languageIcon, setlaguageIcon] = useState('block');
  const [languageWidth, setlaguageWidth] = useState('75px');
  const divRef = useRef<HTMLDivElement>(null);
  const [flag, setFlag] = useState('flex');
  const changeLocale = useChangeLocale();
  const {showSidebar, setShowSidebar, isdarkMode, setIsDarkMode} =
    useToggleSidebar();
  const showNotifButton = !isMobile && isLoggedIn && notifications?.integrated;
  const {data} = useValueLists(['localizations']);
  const {mergeBootstrapData, data: currentData} = useBootstrapData();
  const [showPopUp, setShowPopUp] = useState(false);
  console.log('data', user?.subscriptions);
  let isSubscribed = false;
  if (user?.subscriptions) {
    isSubscribed = user?.subscriptions.length > 0;
  }
  console.log('isSubscribed', isSubscribed);
  const lag = currentData.language;
  // console.log('lag123', lag);
  const localizations = data?.localizations || [];
  console.log('localizations', localizations);
  const [val, setVal] = useState(lag);
  if (isDarkMode) {
    color = darkModeColor;
  }
  const handleLanguage = () => {
    setFlag('flex');
    setlaguageIcon('none');
    setlaguageWidth('265px');
  };
  // start of rain
  
  // function makeItRain() {
  //   console.log('🎊🎊🎊🎊🎊🎊🎊🎊🎊🎊🎊🎊🎊🎊🎊🎊🎊🎊🎊Confetti triggered'); // Debugging
  //   var end = Date.now() + 2 * 1000; // 2 seconds of confetti
  //   var colors = [
  //     '#33fff6',
  //     '#7900BD ',
  //     '#ff33f6',
  //     '#7aff33',
  //     '#fa6530',
  //     '#ffff33',
  //     '#fff',
  //   ]; // Confetti colors

  //   function frame() {
  //     window.confetti({
  //       particleCount: 5,
  //       angle: 60,
  //       spread: 55,
  //       origin: {x: 0},
  //       colors: colors,
  //     });
  //     window.confetti({
  //       particleCount: 5,
  //       angle: 120,
  //       spread: 55,
  //       origin: {x: 1},
  //       colors: colors,
  //     });

  //     if (Date.now() < end) {
  //       requestAnimationFrame(frame);
  //     }
  //   }
  //   frame();
  // }

  //end of rain
  const handleChange = (value: string) => {
    // onValueChange(value as string);
    if (typeof value === 'string') {
      setVal(value);
      changeLocale.mutate({locale: value});
    }
  };
  const handleClickOutside = (event: MouseEvent) => {
    console.log('Hello', divRef.current);
    if (divRef.current && !divRef.current.contains(event.target as Node)) {
      setFlag('none');
      setlaguageIcon('block');
      setlaguageWidth('75px');
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  console.log('val', localizations, hideLogo);
  return (
    <>
      <div
        className={clsx(
          `flex justify-between items-center gap-10 sticky top-0 ${isdarkMode ? "dashboard-grid-navbar-darkmode" : "dashboard-grid-navbar"} pr-50`,
          // isMobile ? 'pl-14 pr-8' : 'px-20',
          color === 'primary' && ` ${textColor || 'text-on-primary'} `,
          color === 'bg' && `bg ${textColor || 'text-main'} `,
          color === 'bg-alt' && `bg-alt ${textColor || 'text-main'} `,
          color === 'transparent' &&
            `bg-transparent ${textColor || 'text-white'}`,
          size === 'md' && 'h-64 pt-4',
          size === 'sm' && 'h-54',
          size === 'xs' && 'h-48 pt-2',

          className
        )}
      >
        {!hideLogo && (
          <Logo isMobile={isMobile} color={color} logoColor={logoColor} />
        )}
        <span
          onClick={() => {
            setShowSidebar(!showSidebar);
          }}
        >
          {toggleButton}
        </span>
        {children}
        {isMobile ? (
          <MobileMenu position={menuPosition} />
        ) : (
          //  <DesktopMenu position={menuPosition} />
          <></>
        )}
        <div
          onClick={() => {
            setIsDarkMode(!isdarkMode);
          }}
          className="cursor-pointer"
        >
          {/* {isdarkMode ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill={`${isdarkMode ? 'black' : 'none'}`}
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 12.79A9 9 0 0111.21 3 7 7 0 0012 21a9 9 0 009-8.21z" />
            </svg>
            // <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-moon absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100"><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"></path></svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 12.79A9 9 0 0111.21 3 7 7 0 0012 21a9 9 0 009-8.21z" />
            </svg>
            // <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-sun h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0"><circle cx="12" cy="12" r="4"></circle><path d="M12 2v2"></path><path d="M12 20v2"></path><path d="m4.93 4.93 1.41 1.41"></path><path d="m17.66 17.66 1.41 1.41"></path><path d="M2 12h2"></path><path d="M20 12h2"></path><path d="m6.34 17.66-1.41 1.41"></path><path d="m19.07 4.93-1.41 1.41"></path></svg>
          )} */}
          {isdarkMode ? (
  // Moon Icon for Dark Mode
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="white"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-moon"
  >
    <path d="M21 12.79A9 9 0 0111.21 3 7 7 0 0012 21a9 9 0 009-8.21z" />
  </svg>
) : (
  // Sun Icon for Light Mode
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="black"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-sun"
  >
    <circle cx="12" cy="12" r="4"></circle>
    <path d="M12 2v2"></path>
    <path d="M12 20v2"></path>
    <path d="m4.93 4.93 1.41 1.41"></path>
    <path d="m17.66 17.66 1.41 1.41"></path>
    <path d="M2 12h2"></path>
    <path d="M20 12h2"></path>
    <path d="m6.34 17.66-1.41 1.41"></path>
    <path d="m19.07 4.93-1.41 1.41"></path>
  </svg>
)}
        </div>
        <div
          className={clsx(
            'justify-self-end flex items-center',
            isMobile ? 'gap-4' : 'gap-14'
          )}
        >
          {/* <Select
      
     
      className={clsx(
        
        isMobile ? 'none-cls' : 'md-25')}
      selectionMode="single"
      selectedValue={val}
      onSelectionChange={value => {
       // onValueChange(value as string);
        console.log(value);
        if (typeof value === 'string') {
          setVal(value);
          changeLocale.mutate({locale: value});
        } 
        
      }}
    >
      
      {localizations.map(localization => (
        <Item key={localization.language} value={localization.language}>
         {localization.name}
        </Item>
      ))}
    </Select> */}
          {rightChildren}
          {showNotifButton && <NotificationDialogTrigger />}
          {isLoggedIn ? (
            <NavbarAuthUser items={authMenuItems} />
          ) : (
            <NavbarAuthButtons
              navbarColor={color}
              primaryButtonColor={primaryButtonColor}
            />
          )}

          <div className="modalAI-wrapper-image">
            <div
              className="hover-target"
              onClick={function () {
                console.log('Hover detected'); // Debugging
                setShowPopUp(true);
                // makeItRain();
              }}
              onMouseLeave={() => {
                setShowPopUp(false);
              }}
            >
              <img
                src="./images/AI.png"
                id="aiIcon"
                width={50}
                style={{marginRight: 5}}
              />
            </div>
            {/* <div className="modalAI">
              <div
                style={{
                  position: 'relative',
                  width: `${window.innerWidth <= 576 ? '100vw' : '100%'}`,
                  height: `${window.innerWidth <= 576 ? '34vh' : '47vh'}`,
                }}
              >
                <Lottie
                  loop
                  play
                  animationData={animationData}
                  style={{
                    width: `${window.innerWidth <= 576 ? '100vw' : '100%'}`,
                    height: '100%',
                    objectFit: 'cover',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: 0,
                  }}
                />

                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    zIndex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    // padding: '1rem',
                    color: '#ffffff',
                    textAlign: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)', // Optional: dim the bg
                    // color: '#fff',
                  }}
                >
                  <p>
                    <Trans message="CAI - ConiaSoft Artificial Intelligence" />
                  </p>
                  <p>
                    <Trans message="Unleash Your Potential with Cutting-Edge AI" />
                  </p>
                  <p>
                    <Trans message="Transform your business with ConiaSoft’s innovative AI solutions! Boost performance, drive growth, and gain a competitive edge." />
                  </p>
                  <p>
                    <Trans message="Contact us at" />

                    <a href="mailto:CAl@ConiaSoft.com">CAI@ConiaSoft.com</a>

                    <Trans message="and shape the future!" />
                  </p>
                  <p>
                    <Trans message="CAI - ConiaSoft Artificial Intelligence  – Intelligence that Inspires." />
                  </p>
                </div>
              </div>
            </div> */}
            <div
              className={`${styles.aipopup}`}
              id="aiPopup"
              style={
                showPopUp
                  ? {display: 'block', opacity: 1}
                  : {display: 'none', opacity: 0}
              }
            >
              <div className={`${styles.aipopupcontent} `}>
                <h2
                  className={`tw-text-xl tw-font-bold tw-text-purple-600 my-5 `}
                >
                  <Trans message="CAI - ConiaSoft Artificial Intelligence" />
                </h2>

                <p>
                <Trans message="CAI - ConiaSoft Artificial Intelligence  – Intelligence that Inspires." />
                </p>

                <p className={`tw-text-gray-600 tw-mt-4 my-5 `}>
                <Trans message="Transform your business with ConiaSoft’s innovative AI solutions! Boost performance, drive growth, and gain a competitive edge." />
                 </p>
                 <p>
                 <Trans message="Contact us at " />

<a href="mailto:CAl@ConiaSoft.com">CAI@ConiaSoft.com</a>

<Trans message=" and shape the future!" />
                 </p>
              <p>
                 <Trans message="CAI - ConiaSoft Artificial Intelligence  – Intelligence that Inspires." />
                 </p> 
                <img
                  src={'./images/AI.png'}
                  alt="AI Teaser"
                  className={`${styles.aipopupimage} tw-mt-6 mx-auto `}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        ref={divRef}
        className={`language_section  p-2  rounded  overflow-hidden fixed z-50 ${isdarkMode?"bg-[#202124] text-white": "bg-whites"} `}
        style={{width: languageWidth, height: '72px', marginRight: '7px'}}
      >
        <span
          className="w-[50px] h-[50px] flex justify-center items-center rounded cursor-pointer"
          style={{display: languageIcon}}
        >
          <img
            src="./images/Languages.png"
            width={50}
            height={50}
            className="bg-primary1 text-white rounded"
            onClick={handleLanguage}
          />
        </span>
        <div
          className="flex justify-start items-center gap-2"
          style={{width: '100%', height: '100%'}}
        >
          {/* {localizations.map(localization => (
            <>
              {val === localization.language ? (
                <div
                  className="flex justify-start items-center gap-2 opacity-100 cursor-default flag"
                  style={{display: flag}}
                >
                  <span
                    className="w-[30px] h-[30px] overflow-hidden"
                    onClick={() => handleChange(localization.language)} // Pass a function reference
                  >
                    {localization.name === 'English' ? <></> : <></>}
                  </span>
                  <span
                    onClick={() => handleChange(localization.language)}
                    style={{
                      fontWeight: 'bold',
                      fontSize: '19px',
                      marginLeft: '7px',
                      marginRight: '7px',
                    }}
                  >
                    {localization.name == 'English' ? 'English' : 'Türkçe'}
                  </span>
                </div>
              ) : (
                <div
                  className="flex justify-start items-center gap-2 opacity-50 cursor-default flag"
                  style={{display: flag}}
                >
                  <span
                    className="w-[30px] h-[30px] overflow-hidden"
                    onClick={() => handleChange(localization.language)} // Pass a function reference
                  >
                    {localization.name === 'English' ? (
                      <></>
                    ) : (
                      // <img
                      //   src="./images/us_logo-3c7dbae7.png"
                      //   width={30}
                      //   height={30}
                      //   alt="En_Logo"
                      //   className="w-full h-full object-contain"
                      // />
                      <></>
                      // <img
                      //   src="./images/turkey_logo-2ce1ee4c.png"
                      //   width={30}
                      //   height={30}
                      //   alt="En_Logo"
                      //   className="w-full h-full object-contain"
                      // />
                    )}
                  </span>
                  <span
                    onClick={() => handleChange(localization.language)}
                    style={{
                      fontWeight: 'bold',
                      fontSize: '19px',
                      marginLeft: '7px',
                      marginRight: '7px',
                    }}
                  >
                    {localization.name == 'English' ? 'English' : 'Türkçe'}
                  </span>
                </div>
              )}
            </>
          ))} */}

          {localizations.map(localization =>
            val === localization.language ? (
              <div
                key={localization.id}
                className="flex justify-start items-center gap-2 opacity-100 cursor-pointer flag"
                style={{display: flag}}
              >
                <span
                  onClick={() => handleChange(localization.language)}
                  style={{
                    fontWeight: 'bold',
                    fontSize: '19px',
                    marginLeft: '7px',
                    marginRight: '7px',
                    color: '#f16623',
                  }}
                >
                  {localization.name}
                </span>
              </div>
            ) : (
              <div
                key={localization.id}
                className="flex justify-start items-center gap-2 opacity-50 cursor-pointer flag"
                style={{display: flag}}
              >
                <span
                  onClick={() => handleChange(localization.language)}
                  style={{
                    fontWeight: 'bold',
                    fontSize: '19px',
                    marginLeft: '7px',
                    marginRight: '7px',
                  }}
                >
                  {localization.name}
                </span>
              </div>
            )
          )}
        </div>
      </div>
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          color: '#fff',
          textAlign: 'center',
          padding: '20px 10px 30px',
          height: '60px',
          fontSize: '14px',
          fontWeight: '400',
          backgroundColor: isdarkMode ? '#202124' : '#006cb6',
          marginTop: '10px',
          zIndex: 20,
        }}
      >
        <Trans message="Ⓒ 2023 - 2025 All Rights Reserved. Designed & Developed by ConiaSoft Ⓡ Yazılım Teknolojileri Limited Şirketi." />
      </div>
    </>
  );
}

interface DesktopMenuProps {
  position: NavbarProps['menuPosition'];
}
function DesktopMenu({position}: DesktopMenuProps) {
  return (
    <CustomMenu
      className="text-sm mx-14"
      itemClassName={isActive =>
        clsx(
          'opacity-90 hover:underline hover:opacity-100',
          isActive && 'opacity-100'
        )
      }
      menu={position}
    />
  );
}

interface MobileMenuProps {
  position: NavbarProps['menuPosition'];
}
function MobileMenu({position}: MobileMenuProps) {
  const navigate = useNavigate();
  const menu = useCustomMenu(position);

  if (!menu?.items.length) {
    return null;
  }

  const handleItemClick = (item: MenuItemConfig) => {
    if (item.type === 'route') {
      navigate(item.action);
    } else {
      window.open(item.action, item.target)?.focus();
    }
  };

  return (
    <MenuTrigger>
      <IconButton>
        <MenuIcon />
      </IconButton>
      <Menu>
        {menu.items.map(item => {
          const Icon = item.icon && createSvgIconFromTree(item.icon);
          return (
            <Item
              value={item.action}
              onSelected={() => handleItemClick(item)}
              key={item.id}
              startIcon={Icon && <Icon />}
            >
              <Trans message={item.label} />
            </Item>
          );
        })}
      </Menu>
    </MenuTrigger>
  );
}

interface LogoProps {
  isMobile: boolean | null;
  color: NavbarProps['color'];
  logoColor: NavbarProps['logoColor'];
}
function Logo({color, isMobile, logoColor}: LogoProps) {
  const {trans} = useTrans();
  const {branding} = useSettings();
  const isDarkMode = useIsDarkMode();

  let desktopLogo: string;
  let mobileLogo: string;
  if (
    isDarkMode ||
    !branding.logo_dark ||
    (logoColor !== 'dark' && (color === 'primary' || color === 'transparent'))
  ) {
    desktopLogo = branding.logo_light;
    mobileLogo = branding.logo_light_mobile;
  } else {
    desktopLogo = branding.logo_dark;
    mobileLogo = branding.logo_dark_mobile;
  }

  const logoUrl = isMobile ? mobileLogo || desktopLogo : desktopLogo;
  if (!logoUrl) {
    return null;
  }

  return (
    <div className="img-Style">
      <Link
        to="/drive"
        className={clsx(
          'block flex-shrink-0 h-full',
          isMobile ? 'none-clsq' : ''
        )}
        aria-label={trans({message: 'Go to homepage'})}
      >
        <img src="./images/cc.png" className="logo-img" alt="Logo" />
      </Link>
    </div>
  );
}
